<template>
  <div class="tools-box">
    <div class="tools-content" v-if="!hideToolsFlag">
      <div class="toggle-tools" @click="hideToolsFlag = true">收起</div>
      <div v-for="(item, index) of toolsArr" :key="index">
        <div class="tool-item" v-if="item.isShow"
             @mouseover="item.showContentFlag = true"
             @mouseleave="item.showContentFlag = false"
             @click="item.clickHandle()">
          <i class="icon" :class="item.icon"></i>
          <span class="tool-item-text">{{item.title}}</span>
          <div class="tool-item-component" :style="item.showContentStyle" v-if="item.showContentFlag" v-html="item.showContentHtml"></div>
        </div>
      </div>
    </div>
    <el-backtop target="body" :visibilityHeight="100" :bottom="200" v-if="!hideToolsFlag">
      <div class="roll-back-icon"><i class="el-icon-arrow-up"></i><span class="tool-item-text">回到顶部</span></div>
    </el-backtop>

    <div class="tools-content-off" v-if="hideToolsFlag" title="展开" @click="hideToolsFlag = false"><i class="el-icon-s-fold" style="margin-top: 3px"></i></div>
  </div>
</template>

<script>
export default {
  name: 'ToolsBox',
  data () {
    return {
      weChatIcon: {
        backgroundImage: `url(${require('../../assets/wx.png')})`,
        width: '20px',
        height: '20px',
        backgroundSize: 'cover'
      },
      weChatNumBg: {
        backgroundImage: `url(${require('../../assets/wechat.jpg')})`,
        width: '180px',
        height: '180px',
        backgroundSize: 'cover'
      },
      showWeChatNumBg: false,
      toolsArr: [
        {
          title: '我的收藏',
          icon: 'el-icon-star-off',
          isShow: this.$store.get('user') && this.$store.get('user').roleName !== 'enterprise',
          showContentFlag: false,
          showContentStyle: {
            display: 'none'
          },
          clickHandle: () => {
            this.$router.push({
              name: 'MyFollow',
              params: null
            })
          }
        },
        {
          title: '我的投递',
          icon: 'el-icon-document-checked',
          isShow: this.$store.get('user') && this.$store.get('user').roleName !== 'enterprise',
          showContentFlag: false,
          showContentStyle: {
            display: 'none'
          },
          clickHandle: () => {
            this.$router.push({
              name: 'MyApply',
              params: null
            })
          }
        },
        {
          title: `公  众  号`,
          icon: 'el-icon-s-grid',
          isShow: true,
          showContentFlag: false,
          showContentStyle: {
            backgroundImage: `url(${require('../../assets/wechat.jpg')})`,
            width: '180px',
            height: '180px',
            backgroundSize: 'cover'
          },
          clickHandle: () => {}
        },
        {
          title: `联系我们`,
          icon: 'el-icon-chat-dot-square',
          isShow: true,
          showContentFlag: false,
          showContentStyle: {
            width: '220px',
            height: 'auto !important',
            left: '-220px',
            background: '#ffffff'
          },
          showContentHtml: `<div style="padding: 10px">
                              <div><i class="el-icon-phone-outline content-icon"></i><span>电话：0571-86733626</span></div>
                              <div style="padding-left: 60px"><span>13916244409</span></div>
                              <div><i class="el-icon-message content-icon"></i><span>邮箱：3156828380@qq.com</span></div>
                            </div>`,
          clickHandle: () => {}
        }
      ],
      hideToolsFlag: false
    }
  }
}
</script>

<style scoped>
  /deep/ .el-backtop {
    width: 100px;
    height: 28px;
    line-height: 28px;
    border-radius: 0;
    /*box-shadow: none;*/
  }
  .roll-back-icon {
    width: 100px;
    /*height: 40px;*/
  }
  .tool-item-text {
    white-space: pre;
    margin-left: 6px;
    font-size: 14px;
    color: #313131;
  }

  .tools-content {
    position: fixed;
    background: #ffffff;
    box-shadow: 0 0 6px rgba(0,0,0,.12);
    bottom: 230px;
    right: 40px;
  }
  .tool-item {
    width: 100px;
    height: 28px;
    line-height: 28px;
    text-align: left;
    display: flex;
    -webkit-box-align: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
  }
  .tool-item:hover {
    background-color: #F2F6FC;
  }
  .icon {
    font-size: 20px;
    line-height: 28px;
    color: #409eff;
  }

  .tool-item-component {
    position: absolute;
    width: 100px;
    height: 100px;
    background: #cccccc;
    left: -180px;
  }
  /deep/ .content-icon {
    color: #fc6c38;
    margin-right: 5px;
  }
  .toggle-tools:hover {
    cursor: pointer;
    color: #409eff;
  }
  .tools-content-off {
    position: fixed;
    background: #ffffff;
    -webkit-box-shadow: 0 0 6px rgba(0,0,0,.12);
    box-shadow: 0 0 6px rgba(0,0,0,.12);
    bottom: 350px;
    right: 15px;
    font-size: 15px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    padding-top: 0;
    cursor: pointer;
  }
  .tools-content-off:hover{
    color: #409eff;
    transform: scale(1.2);
  }
</style>



// WEBPACK FOOTER //
// src/components/ToolsBox/ToolsBox.vue